import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Link } from '@fiverr-private/typography';
import type { NicheCardProps } from '../NicheCard.types';
import { NicheCardContent } from '../NicheCardContent';
import { linkCard } from '../NicheCard.ve.css';
import { LINK_IMAGE_SIZE } from '../NicheCard.constants';
import { reportNicheCardLinkClick } from './reportNicheCardLinkClick';

const STEP_SLUG = 'choose-banners';
const PLATFORM = 'shopify';

export const NicheCardLink: React.FC<NicheCardProps> = ({ displayName, url, id, onClick, biEventData, pageName }) => {
    const href = pathfinder(
        'ai_store_builder_wizard',
        {
            platform: PLATFORM,
            step_slug: STEP_SLUG,
        },
        {
            query: {
                niche: id.toString(),
            },
        }
    );

    const handleClick = () => {
        if (biEventData && pageName) {
            reportNicheCardLinkClick({ biEventData, pageName, chosenNiche: { id, displayName, url } });
        }
        onClick?.();
        window.open(href, '_blank');
    };

    return (
        <Link
            className={linkCard}
            onClick={handleClick}
            decoration={{ default: 'none', hover: 'underline' }}
            cursor="pointer"
        >
            <NicheCardContent displayName={displayName} url={url} imageSize={LINK_IMAGE_SIZE} />
        </Link>
    );
};

NicheCardLink.displayName = 'NicheCardLink';
